import * as React from "react"
import * as LabelPrimitive from "@radix-ui/react-label"

import { cn } from "@/lib/utils"
import { FormParamStatus } from "@/lib/form/types"

export interface LabelProps
  extends React.ComponentProps<typeof LabelPrimitive.Root> {
  status?: FormParamStatus
}

function Label({ className, ...props }: LabelProps) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn(
        `
          text-label-text flex items-center gap-2
          text-sm font-normal select-none 
          group-data-[disabled=true]:pointer-events-none
          group-data-[disabled=true]:opacity-50
          peer-disabled:cursor-not-allowed
          not-peer-disabled:hover:cursor-pointer -truncate
        `,
        props.status === FormParamStatus.SUBMITTED &&
        "not-peer-disabled:hover:cursor-auto",
        className
      )}
      {...props}
    />
  )
}

export { Label }
